import {
	AppGridHeard as AppGridHeardProps,
	AppGridLayout as AppGridLayoutProps,
	AppGridSearch as AppGridSearchProps,
	AppGridView as AppGridViewProps,
	AppSearchData,
} from 'api'
import modelingApi from 'api/modelingApi'
import { AppTable } from 'components/AppTable'
import { ITableProps } from 'components/AppTable/AppTable'
import { AppGridSearch } from 'components/AppTableSearch/AppGridSearch'
import { default as React, forwardRef, Fragment, useState, useRef, useEffect } from 'react'
import { AppGridContext } from './AppGridData'
import { AppGridHeard } from './AppGridHeard'
import AppGridLayout from './AppGridLayout'
import AppGridMenu from './AppGridMenu'
import AppGridView from './AppGridView'
import AppTableAction from 'components/AppAction/AppTableAction'
import AppAction from 'components/AppAction/AppAction'
import AppGridTabs from './AppGridTabs'
import AppGridTab from './AppGridTab'

export interface AppGridProps extends AppGridLayoutProps {
	id?: number
	application?: string
	appSearchDataList?: any[]
}

export let AppGrid = (props: AppGridProps) => {
	const [GridList, setGridList] = useState(props)
	const onSearch = (appSearchDataList: AppSearchData[]) => {
		// 1
		refAppTable &&
			refAppTable.current &&
			refAppTable.current.queryGrid({
				appSearchDataList: [...appSearchDataList],
			})
	}
	useEffect(() => {
		refAppTable && refAppTable.current && refAppTable.current.queryGrid({})
	}, [props])
	const renderGridSearch = (GridSearch: AppGridSearchProps) => {
		return (
			<AppGridSearch
				{...GridSearch}
				onSearch={onSearch}
				advancedSearch={GridSearch.appGridAdvancedSearch}
				commonSearchList={GridSearch.appGridCommonSearch.appGridCommonSearchItemList}
			/>
		)
	}

	const renderGridHeard = (GridHeard: AppGridHeardProps, AppGridViewList: AppGridViewProps[]) => {
		return (
			<AppGridHeard>
				{
					<AppGridTabs>
						{AppGridViewList.length > 1 &&
							AppGridViewList.map((Tab, indexTab) => {
								return <AppGridTab {...Tab} key={indexTab + 'AppGridTab'} />
							})}
					</AppGridTabs>
				}
				{
					<AppGridMenu>
						{GridHeard &&
							GridHeard.appGridMenu &&
							GridHeard.appGridMenu.appActionList &&
							GridHeard.appGridMenu.appActionList.map((Action, indexMenu) => {
								return <AppAction key={'indexMenu' + indexMenu} {...Action} />
							})}
					</AppGridMenu>
				}
			</AppGridHeard>
		)
	}

	const refAppTable = useRef<AppTable>()
	const renderGridView = (AppGridViewList: AppGridViewProps[]) => {
		return (
			<Fragment>
				{AppGridViewList.map((view, indexView) => {
					return (
						<AppGridView viewId={view.viewId} key={'indexView' + indexView}>
							{
								<AppTable
									ref={refAppTable}
									{...view.appTable}
									api={modelingApi.postPageList}
									data={{
										appSearchDataList: props.appSearchDataList,
										pageId: props.id,
										application: props.application,
										viewId: view.viewId,
									}}
								>
									{view.appTable.showIndexColumn ? (
										<AppTable.ColIndex title="序号" width={50} />
									) : null}
									{view.appTable.appTableColList &&
										view.appTable.appTableColList.map((TableCol, indexTableCol) => {
											return <AppTable.Col {...TableCol} key={'indexTableCol' + indexTableCol} />
										})}
									{view.appTable.colActionWidth && view.appTable.tableActionList ? (
										<AppTable.ColAction
											width={view.appTable.colActionWidth}
											render={(data: any) => {
												return (
													<Fragment>
														{view.appTable.tableActionList.map(
															(tableAction, indextableAction) => {
																return (
																	<AppTableAction
																		{...tableAction}
																		onClick={e =>
																			(tableAction as any).onClick &&
																			(tableAction as any).onClick(data)
																		}
																		label={tableAction.title}
																		key={'indextableAction' + indextableAction}
																	/>
																)
															}
														)}
													</Fragment>
												)
											}}
										/>
									) : null}
								</AppTable>
							}
						</AppGridView>
					)
				})}
			</Fragment>
		)
	}

	const { appGridSearch, appGridHeard, appGridViewList } = props
	return (
		<AppGridContext.Provider
			value={{
				GridData: GridList,
			}}
		>
			<AppGridLayout defaultViewId={1} {...props}>
				{appGridSearch ? renderGridSearch(appGridSearch) : null}
				{(appGridHeard && appGridHeard.appGridMenu && appGridHeard.appGridMenu.appActionList) ||
				appGridViewList.length > 1
					? renderGridHeard(appGridHeard, appGridViewList)
					: null}
				{appGridViewList ? renderGridView(appGridViewList) : null}
			</AppGridLayout>
		</AppGridContext.Provider>
	)
}
AppGrid = forwardRef(AppGrid)



// WEBPACK FOOTER //
// ./src/components/AppGridLayout/AppGrid.tsx